import React, { Component } from 'react';
import moment from 'moment'

import Card from 'react-bootstrap/Card'
import Badge from 'react-bootstrap/Badge'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


class ContentsCard extends Component {
  renderProgress() {
    const task = this.props.item
    return <Row>
      <Col sm={12} className='RecommendDetail'>
        {task.data.completed && <span>
          <Badge variant='success'>完了</Badge>{' '}
        </span>}
        {!task.data.completed && <span>
          <Badge variant='danger'>途中</Badge>{' '}
        </span>}
        {parseInt(task.data.rate * 100)}%
      </Col>
      <Col sm={8} className='RecommendDetail'>
        ベストスコア: {task.data.score} / {task.data.scoreTotal}
      </Col>
      <Col sm={4} className='RecommendType'>
        <a href={`${this.props.baseURL}/?task_id=${task.id}&quiz=1`}>
          <Badge variant='primary'>→単語クイズ</Badge>
        </a>
      </Col>
    </Row>
  }

  render() {
    const { content } = this.props
    const imgsrc = (content && content.data && content.data.thumbnail) || null
    const cardContent = content.data && <Row className='RecommendContents'>
      <Col sm={12}>
        <span className='RecommendHeader'>
          <a href={`${this.props.baseURL}/contents/${content.id}`}>{content.data.title}</a>
        </span>
        {content.data.updated && content.data.accessed &&
          content.data.updated > content.data.accessed &&
          <Badge variant='danger'>New!</Badge>}
      </Col>
      <Col sm={12} className='RecommendAccessed'>
        <span className='ContentsCount'>
          コンテンツ数:
          {content.data.cloze ? content.data.cloze.length : '-'}
        </span>
        {content.data.updated && <span className='ContentsUpdated'>
            最終更新:
            {moment(new Date(content.data.updated)).fromNow()}
          </span>}
        <span className='ContentsAccess'>
          最終アクセス:
          {content.data.accessed ? moment(new Date(content.data.accessed)).fromNow() : '-'}
        </span>
      </Col>
    </Row>
    return <div className='RecommendCard'>
      <Card className={`${imgsrc && 'RecommendImage'} h-100`} style={imgsrc && {'background-image': `url('${imgsrc}')`}}>
        <Card.Body className={imgsrc && 'RecommendOverlay'}>{cardContent}</Card.Body>
      </Card>
    </div>
  }
}

export default ContentsCard;
